export default Object.freeze({
  SIGNED_IN: "Signed in",
  SIGNED_OUT: "Signed out",
  CHECKED_IN: "Checked in",
  CHECKED_OUT: "Checked out",
  DENIED: "Denied",
});

export const deletedUserString = "_deleted";

export const areaModes = {
  NORMAL: "normal",
  REMOTE: "remote",
}

export const journeyBuilderSettingsIDS = {
  show_user_type: "10",
  show_temperature: "11",
  print_badge_journey_company_logo: "113",
  print_badge_host: "114",
  print_badge_late_sign_in_reason: "115",
  print_badge_early_sign_out_reason: "116",
  show_company_name: "12",
  show_date_time: "13",
  show_photo: "8",
  show_name: "9",
};
